
import axios from '../../assets/js/baseaxios'

const state = {
    isEasy: false, //是否是简易流程
    IsPC: true, //是否是pc端 true是
    isXCX: false, //是否从小程序进来的
    lang: '', //语言类型
    fphone: '', //手机号
    // 身份证信息
    positiveImg: '', //正面
    negativeImg: '', //反面
    fcardUrl: '', //身份证正面照的人脸照片
    faceImage: '', //人脸照
    IdCodename: '', //姓名
    IdCodeNO: '', //身份证号
    IdCodeType: '', //证件类型
    country: '', //国家
    address: '', //身份证上的地址
    IdfpersonGender: '', //性别
    IdfpersonNation: '', //民族
    IdfpersonBirthday: '', //出生日期
    userCompany: '', //单位名称
    userJob: '', //职务
    isCompare: false, //证件比对
    userEmail: '', //邮箱号
    userInfoState:{},
    fquestionId: '', //问卷信息
}

//申明同步

const mutations = {
    setMemu(state,obj){
        state[obj.name] = obj.value
    }
}
//
const actions = {
    //获取用户审核状态
    getStatus({commit, state}, obj){
        let num = ''
        if(state.lang === 'en'){
            num = state.userEmail
        }else{
            num = state.fphone
        }
        let { el, bool } = obj
        return new Promise((resolve,reject)=>{
            axios.get('/findRecordByPhone',{
                params:{
                    phone: num,
                    entryType: state.lang,
                    fquestionId: state.fquestionId,
                }
            }).then(res=>{
                if(res.data.success){
                    if(!res.data.items){
                        if(state.isEasy){
                            //简易流程
                            el.$router.push({path: '/userInfoPage'})
                        }else{
                            el.$router.push({path: '/idCard'})
                            // if(state.lang === 'en'){
                            //     //国际版 跳过身份证输入
                            //     el.$router.push({path: '/userInfoPage'})
                            // }else{
                            //     el.$router.push({path: '/idCard'})
                            //
                            // }
                        }
                      }else{
                        let item = res.data.items[0]
                        commit({
                          type: 'setMemu',
                          name: 'userInfoState',
                          value: item
                        })
                        el.$router.push({path: '/resultState', query:{isTime: bool}})
                      }
                    resolve(res)
                }else{
                    el.$toast(res.data.msg)
                    reject()
                }
            })
        })
    }
}

export default {
    state,
    mutations,
    actions
}
